import { render, staticRenderFns } from "./BindMobile.vue?vue&type=template&id=5028d6fb&scoped=true&"
import script from "./BindMobile.vue?vue&type=script&lang=js&"
export * from "./BindMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028d6fb",
  null
  
)

export default component.exports